import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { PartnerEngagementConfigurationListType,PartnerEngagementCategoryListType} from "./Types";

type LastDraftFormFields = {
    assessment_date?: string;
    next_assessment_date?: string;
    comment?: string;
};

type initialStateType = {
    eventOverviewList: any;
    eventPointList:any;
    eventPointSummary:any;
    eventPointDraftSummary:any;
    /** Last saved draft assessment dates + comment (keyed by partner ID) for persistence when API doesn't return them */
    lastDraftFormFieldsByPartner: Record<number, LastDraftFormFields>;
    fileUrl:string;
    status: {
        eventListConfigurationStatus: boolean;
        eventListConfigurationLoading: boolean;
        eventListConfigurationMessage: string;
         addEventConfigurationStatus: boolean;
        addEventConfigurationLoading: boolean;
        evaluationSuccess:boolean;
        submitEvaluationConfigurationLoading:boolean;
        addEventConfigurationMessage: string;
        evaluationMessage:string;
        updatePartnerPointsLoading: boolean;
        deletePartnerPointsLoading: boolean;
        partnerPointsMutationMessage: string;
    }
}

var initialState: initialStateType = {
    eventOverviewList:[],
    eventPointList:[],
    eventPointSummary:[],
    eventPointDraftSummary:[],
    lastDraftFormFieldsByPartner: {},
    fileUrl:'',
    status: {
        eventListConfigurationStatus: false,
        eventListConfigurationLoading: false,
        eventListConfigurationMessage: "",
        evaluationSuccess:false,
         addEventConfigurationStatus: false,
        addEventConfigurationLoading: false,
        addEventConfigurationMessage: '',
        submitEvaluationConfigurationLoading:false,
        evaluationMessage:'',
        updatePartnerPointsLoading: false,
        deletePartnerPointsLoading: false,
        partnerPointsMutationMessage: '',
    }
}

const partnerProgramEventConfigurationSlice = createSlice({
    name: "partner_program_event_configuration",
    initialState: initialState,
    reducers: {
 
        setEventListConfigurationStatus: (state, action) => {
            state.status.eventListConfigurationStatus = action.payload;
        },
        setEventConfigurationMessage: (state, action) => {
            state.status.eventListConfigurationMessage = action.payload;
        },
        setEventConfigurationLoading : (state, action) => {
            state.status.eventListConfigurationLoading = action.payload;
        },
          setEventListData: (state, action) => {
            state.eventOverviewList = action.payload;
        },

           setAddEventConfigurationStatus: (state, action) => {
            state.status.addEventConfigurationStatus = action.payload;
        },
        setAddEventConfigurationMessage: (state, action) => {
            state.status.addEventConfigurationMessage = action.payload;
        },
        setAddEventConfigurationLoading : (state, action) => {
            state.status.addEventConfigurationLoading = action.payload;
        },
  setEvaluationConfigurationLoading : (state, action) => {
            state.status.submitEvaluationConfigurationLoading = action.payload;
        },
        setEvaluationConfigurationMessage : (state, action) => {
            state.status.evaluationMessage = action.payload;
        },
         evaluationSuccess : (state, action) => {
            state.status.evaluationSuccess = action.payload;
        },
        
         setEventPointListData : (state, action) => {
            state.eventPointList = action.payload;
        },

             setEventPointSummaryListData : (state, action) => {
            state.eventPointSummary = action.payload;
        },

        setEventPointDraftSummaryListData : (state, action) => {
            state.eventPointDraftSummary = action.payload;
        },

        clearPartnerPointsSummaries: (state) => {
            state.eventPointSummary = [];
            state.eventPointDraftSummary = [];
        },

        setLastDraftFormFields: (state, action: PayloadAction<{ partnerId: number; fields: LastDraftFormFields }>) => {
            const { partnerId, fields } = action.payload;
            state.lastDraftFormFieldsByPartner[partnerId] = fields;
        },

            setFileDataUrl : (state, action) => {
            state.fileUrl = action.payload;
        },

        setUpdatePartnerPointsLoading: (state, action) => {
            state.status.updatePartnerPointsLoading = action.payload;
        },
        setDeletePartnerPointsLoading: (state, action) => {
            state.status.deletePartnerPointsLoading = action.payload;
        },
        setPartnerPointsMutationMessage: (state, action) => {
            state.status.partnerPointsMutationMessage = action.payload;
        },
        
   
   
      
   
    }
})

export const partnerProgramEventConfigurationSliceReducer = partnerProgramEventConfigurationSlice.reducer;
export const partnerProgramEventConfigurationSliceAction = partnerProgramEventConfigurationSlice.actions;